import { FIELD_TYPES } from "constants/template-field-type";
import { DEVLINK_COMPONENT_CONFIGS } from "./constants/devlink-component-types";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Dynamic Devlink",
    fields: {
        devlinkComponent: {
            type: FIELD_TYPES.CONDITIONAL_NESTED,
            label: "Component Configuration",
            conditionalKeyName: "componentType",
            options: Object.entries(DEVLINK_COMPONENT_CONFIGS).map(([componentName, config])=>{
                // Namespace fields by component name to prevent translation key collisions
                const namespacedFields = {};
                const componentKey = componentName.toLowerCase();
                Object.entries(config.props || {}).forEach(([propName, propConfig])=>{
                    namespacedFields[componentKey] = namespacedFields[componentKey] || {
                        type: FIELD_TYPES.NESTED,
                        label: componentName,
                        fields: {}
                    };
                    namespacedFields[componentKey].fields[propName] = propConfig;
                });
                return {
                    text: componentName,
                    type: FIELD_TYPES.NESTED,
                    fieldsConfig: namespacedFields
                };
            })
        }
    }
};
